module.exports = __webpack_public_path__ + "img/日常安全监测运营_m.d3fac37c.png";